<script setup lang="ts">
import type { SectionCanvasXpRecord } from '~/types/datocms'

defineProps<{
  data: SectionCanvasXpRecord
  enabled: boolean
}>()

const isScriptLoaded = ref(false)
const canvasRef = ref<HTMLDivElement | null>(null)

onMounted(() => {
  const script = document.createElement('script')
  script.src = '/prebuilt/main.min.js'
  script.type = 'text/javascript'
  script.defer = true
  script.onload = () => {}

  if (canvasRef.value) {
    canvasRef.value.appendChild(script)
    isScriptLoaded.value = true
  }
})
onBeforeUnmount(() => {
  if (canvasRef.value) {
    let canvasElement = canvasRef.value.querySelector('canvas')
    if (canvasElement) {
      canvasElement = null
    }
  }
})
</script>

<template>
  <div class="h-screen w-screen">
    <div id="blob-canvas" ref="canvasRef" />
    <div
      class="pointer-events-none absolute left-0 top-0 h-full w-full bg-gradient-to-t from-black via-[rgba(0,_0,_0,_0.5)] to-transparent to-10%"
    />
    <Heading
      v-if="data.title"
      class="pointer-events-none absolute left-0 top-1/2 w-fit -translate-y-1/2 px-4 font-black leading-[0.9] text-black mix-blend-overlay invert clamp-[4rem,11vw,10rem] lg:left-1/2 lg:-translate-x-1/2 lg:px-10"
      :level="1"
      :size="undefined"
      :is-semantic="true"
    >
      <TextReveal :text="data.title" :delay="0.6" />
    </Heading>
    <div class="container pb-12 pt-8 lg:page-pt lg:absolute lg:left-0 lg:top-0 lg:justify-between">
      <div
        v-if="data.subtitle"
        class="mb-20 max-w-[24rem] text-lg font-bold lg:mx-auto lg:mr-0 lg:mt-[2vh] lg:text-2xl lg:font-black lg:leading-[1.75]"
      >
        {{ data.subtitle }}
      </div>
    </div>
  </div>
</template>
